import React, { ButtonHTMLAttributes, PropsWithChildren } from 'react';
import { StyledButton } from './styles';

interface Props
  extends PropsWithChildren<ButtonHTMLAttributes<HTMLButtonElement>> {
  background?: 'anti' | 'transparent' | 'danger';
  size?: 'sm' | 'md';
}

export const Button = ({
  children,
  background,
  disabled,
  onClick,
  size = 'md',
  ...props
}: Props) => {
  return (
    <StyledButton
      className={background}
      disabled={disabled}
      onClick={onClick}
      {...props}
      size={size}
    >
      {children}
    </StyledButton>
  );
};
